import { m } from '@sohanscript/i18n';
import { useParams } from '@tanstack/react-router';
import type { ComponentProps } from 'react';
import { PageNav } from '@/components/page-nav';
import { api } from '@/lib/trpc/client';

type WorkNavProps = ComponentProps<'nav'>;

export function WorkNav({ ...props }: WorkNavProps) {
	const { slug } = useParams({ from: '/_main/work/$slug' });
	const [allSlugs] = api.project.allSlugs.useSuspenseQuery();

	const items = (allSlugs ?? []).map((p) => ({
		slug: p.slug?.current ?? '',
		title: p.title ?? '',
	}));

	return (
		<PageNav
			currentSlug={slug}
			itemTo="/work/$slug"
			listTo="/works"
			listLabel={m.work_all()}
			items={items}
			{...props}
		/>
	);
}
